export default __webpack_public_path__ + "static/variations-9fa52d2e6c852ca08687658087817aeb.png";